import tools from "../../../../../helpers/tools";
import { formatProductData } from "../../../../common/ProductInfos/productDataFormatter";

const effectif = (n) => (n === 0 || n === null || n === undefined ? "0" : tools.truenumberWithSpaces(n));
const chiffreAffaires = (n) => (n ? `${tools.truenumberWithSpaces(n)} €` : "N/A");

// Export JSON d'un lead entreprise ou DOMI : produit et réponses, société et
// établissement, contact, nombre de contrats ; particulier et tarif pour DOMI.
export const exporterLeadJson = (lead, productCategory, inputsConfig, constants) => {
  const exportData = {
    lead_id: lead.id,
    produit: {
      type: lead.productId,
      finalisé: lead.isFinalized ? "Oui" : "Non",
      données_produit: formatProductData(lead.productData, inputsConfig, constants),
    },
  };

  if (productCategory === "PRO" && lead.client) {
    exportData.société = {
      nom: lead.client.company,
      siret_siege: lead.client.siret,
      forme_juridique: lead.client.legalForm,
      ape: lead.client.ape,
      activité: lead.client.companyActivity,
      adresse: tools.getFullAddress(lead.client.location1),
      chiffre_affaires: chiffreAffaires(lead.client.turnover),
      effectif: effectif(lead.client.workforce),
      date_immatriculation: tools.formatDate(lead.client.registrationAt),
    };

    if (lead.establishment && !lead.establishment.isHeadOffice) {
      exportData.établissement = {
        nom: lead.establishment.company,
        siret: lead.establishment.siret,
        adresse: tools.getFullAddress(lead.establishment.location),
        chiffre_affaires: chiffreAffaires(lead.establishment.turnover),
        effectif: effectif(lead.establishment.workforce),
        date_immatriculation: tools.formatDate(lead.establishment.registrationAt),
      };
    } else if (lead.establishment) {
      exportData.établissement = {
        note: "Établissement identique au siège social",
        siret: lead.establishment.siret,
        adresse: `${lead.establishment.location?.postalCode} ${lead.establishment.location?.city}`,
        chiffre_affaires: chiffreAffaires(lead.establishment.turnover),
        effectif: effectif(lead.establishment.workforce),
      };
    }

    if (lead.userCustomer) {
      exportData.contact_client = {
        nom_complet: tools.getFullName(lead.userCustomer),
        téléphone: lead.userCustomer.phone || "N/A",
        email: lead.userCustomer.email || "N/A",
      };
    }

    if (lead.nbPolicies !== undefined) {
      exportData.nombre_contrats_perceval = lead.nbPolicies || 0;
    }
  }

  if (productCategory === "DOMI" && lead.user) {
    exportData.particulier = {
      nom: `${lead.user.firstname} ${lead.user.lastname}`,
      téléphone: lead.user.phone || "N/A",
      email: lead.user.email || "N/A",
    };
    if (lead.prices?.length > 0) {
      const lastPrice = lead.prices[lead.prices.length - 1].price;
      exportData.tarif_devis = lastPrice ? `${lastPrice}€` : "N.D";
    }
  }

  const jsonString = JSON.stringify(exportData, null, 2);
  const blob = new Blob([jsonString], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `lead_${lead.id}_${lead.productId}_${new Date().toISOString().split("T")[0]}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
